/* unplugin-vue-components disabled */import script from "./multi-select-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-select-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./multi-select-dialog.vue?vue&type=style&index=0&id=0de03b70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de03b70"]])

export default __exports__